export const opportunityConstant = {
  // Get opportunities by pipeline
  GET_OPPORTUNITIES_BY_PIPELINE_R: "GET_OPPORTUNITIES_BY_PIPELINE_R",
  GET_OPPORTUNITIES_BY_PIPELINE_S: "GET_OPPORTUNITIES_BY_PIPELINE_S",
  GET_OPPORTUNITIES_BY_PIPELINE_F: "GET_OPPORTUNITIES_BY_PIPELINE_F",

  // Get opportunities by stage
  GET_OPPORTUNITIES_BY_STAGE_R: "GET_OPPORTUNITIES_BY_STAGE_R",
  GET_OPPORTUNITIES_BY_STAGE_S: "GET_OPPORTUNITIES_BY_STAGE_S",
  GET_OPPORTUNITIES_BY_STAGE_F: "GET_OPPORTUNITIES_BY_STAGE_F",

  // Get single opportunity
  GET_OPPORTUNITY_R: "GET_OPPORTUNITY_R",
  GET_OPPORTUNITY_S: "GET_OPPORTUNITY_S",
  GET_OPPORTUNITY_F: "GET_OPPORTUNITY_F",

  // Create opportunity
  CREATE_OPPORTUNITY_R: "CREATE_OPPORTUNITY_R",
  CREATE_OPPORTUNITY_S: "CREATE_OPPORTUNITY_S",
  CREATE_OPPORTUNITY_F: "CREATE_OPPORTUNITY_F",

  // Update opportunity
  UPDATE_OPPORTUNITY_R: "UPDATE_OPPORTUNITY_R",
  UPDATE_OPPORTUNITY_S: "UPDATE_OPPORTUNITY_S",
  UPDATE_OPPORTUNITY_F: "UPDATE_OPPORTUNITY_F",

  // Delete opportunity
  DELETE_OPPORTUNITY_R: "DELETE_OPPORTUNITY_R",
  DELETE_OPPORTUNITY_S: "DELETE_OPPORTUNITY_S",
  DELETE_OPPORTUNITY_F: "DELETE_OPPORTUNITY_F",

  // Update opportunity order/stage (for drag & drop)
  UPDATE_OPPORTUNITY_ORDER_R: "UPDATE_OPPORTUNITY_ORDER_R",
  UPDATE_OPPORTUNITY_ORDER_S: "UPDATE_OPPORTUNITY_ORDER_S",
  UPDATE_OPPORTUNITY_ORDER_F: "UPDATE_OPPORTUNITY_ORDER_F",

  // Clear opportunities state
  CLEAR_OPPORTUNITIES_STATE: "CLEAR_OPPORTUNITIES_STATE",
};
